import { jsx as e } from "react/jsx-runtime";
import { hiddenStripePaymentElementTermsOptions as i } from "../constants/stripe-payment-element-options.mjs";
import { useStripe as t, PaymentElement as r } from "../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
function p() {
  return t() ? /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(
    r,
    {
      options: {
        ...i,
        fields: {
          billingDetails: {
            name: "never",
            email: "never"
          }
        }
      }
    }
  ) }) : null;
}
export {
  p as StripeIdealDetails
};
